import { TAGS_MARGIN } from '../constants';

/**
 * @description Функция вычисляет ширину тега с учётом его отступов.
 */
export function getFullTagWidth(tagsOptions, tagIndex, tagsWidthsMap) {
  const currentTag = tagsOptions[tagIndex];
  const tagWidth = tagsWidthsMap[currentTag.value] || 0;
  const nextAddedWidth = tagWidth + TAGS_MARGIN;
  return nextAddedWidth;
}